import { z } from 'zod'

export const baseSchema = z.object({
  structure_name: z.string().min(1),
  value_date: z.string().date(),
  instance_tag: z.union([z.literal('LOCALINST1'), z.literal('LOCALINST2')]),
})

export const npvSchema = baseSchema

const defaultRiskSchema = baseSchema.extend({
  input_type: z.literal('default_risk'),
})

const customRiskSchema = baseSchema.extend({
  input_type: z.literal('custom_risk'),
  spot: z.string().min(1, 'Required for custom risk'),
  vol: z.string().min(1, 'Required for custom risk'),
  div: z.string().min(1, 'Required for custom risk'),
  rate: z.string().min(1, 'Required for custom risk'),
  time: z.string().min(1, 'Required for custom risk'),
})

export const riskSchema = z.discriminatedUnion('input_type', [defaultRiskSchema, customRiskSchema])

const defaultScenarioSchema = baseSchema.extend({
  input_type: z.literal('default_scenario'),
})

const customScenarioSchema = baseSchema.extend({
  input_type: z.literal('custom_scenario'),
  spot: z.array(z.number()).min(1, 'Required for custom scenario'),
  time: z.array(z.number()).min(1, 'Required for custom scenario'),
})

export const scenarioSchema = z.discriminatedUnion('input_type', [
  defaultScenarioSchema,
  customScenarioSchema,
])
